/*
Loons Lab Date picker component
Developed By Roshan
Loons Lab
*/
import React, { Fragment, useState, Component } from "react";
import { Card } from '@material-ui/core'
import { any, string } from "prop-types";

class LoonsCard extends Component {
    static propTypes = {
        title: any,
        children: Node,
        Image: any,
    };

    static defaultProps = {
        title: null,
        Image: null,
    };



    render() {
        const {
            title,
            Image,
            children
        } = this.props;


        return (
            <Card elevation={6} className="px-main-card py-3" style={{backgroundImage: 'url('+ Image +')', backgroundColor:'rgba(255,255,255,0.9)'}}>
                {children}
            </Card>
        );
    }
}

export default LoonsCard;